import { ErrorMessage, Field, Formik } from 'formik'
import { Fragment, useState } from 'react'
import { Helmet } from 'react-helmet'
import { FormGroup, Label } from 'reactstrap'
import { ButtonLoader } from 'utils/storageUtils'
import * as yup from 'yup'
import { CustomButton, HeaderImage, LoginForm, LoginInput, EyeIcon, ForgotPassword } from '../styles'
import RegisterImage from 'assets/images/register-image.svg'
import { handleExternalLink, isZoom } from 'utils/helpers'
import { BsEye, BsEyeSlash } from 'react-icons/bs'
import { useHistory, useLocation } from 'react-router-dom'

export const SocialLoginPasswordComponent = (props) => {
  const [is_submitting, set_is_submitting] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)

  const history = useHistory();
   const { search } = useLocation()
  const searchParams = new URLSearchParams(search);

  return (
    <>
      <Helmet>
        <title>Sign In</title>
      </Helmet>
      <HeaderImage className='col-flex'>
        <img src={RegisterImage} alt='' className='register' />
        <h3 className='login-title'>Sign in to continue</h3>
        <p className='mx-5'>You already have an account associated with this email.
          To log in using your Google account, please enter your
          Klutch password.</p>
      </HeaderImage>
      <Formik
        enableReinitialize
        validateOnBlur={false}
        initialValues={{ password: '', email: searchParams.get('email')}}
        validationSchema={yup.object().shape({
           password: yup.string().required('Password needed')
        })}
        onSubmit={async (fields, form) => {
          try {
            set_is_submitting(true)
            await props.doLogin(fields)
          } catch (error) { }
          set_is_submitting(false)
        }}>
        {(formProps) => (
          <LoginForm onSubmit={formProps.handleSubmit}>
            <FormGroup>
              <Field name='password'>
                {({ field }) => (
                  <>
                    <LoginInput type={passwordVisible ? 'text' : 'password'} id='password' {...field} className={`login-input ${field.value ? 'has-value' : ''}`} />
                    <Label htmlFor='password'>Password</Label>
                    <ErrorMessage name='password' className='error-message' component='div' />
                    {field.value && <EyeIcon onClick={() => setPasswordVisible(!passwordVisible)}>{!passwordVisible ? <BsEye size={20} /> : <BsEyeSlash size={20} />}</EyeIcon>}
                    <ForgotPassword
                      tabIndex={-1}
                      className='witharrow'
                      href='/'
                      onClick={(e) => {
                        e.preventDefault()
                        history.push('/login?fp=true')
                      }}>
                      Forgot password?
                    </ForgotPassword>
                  </>
                )}
              </Field>
            </FormGroup>
            
            <FormGroup className='mb-0'>
              <CustomButton type='submit' className='black btn-block btn-lg' disabled={is_submitting}>
                Login
                {is_submitting && <ButtonLoader />}
              </CustomButton>
              <br />
              {/* {!isZoom() && <SocialLogin component='Register' invitation={{}} />} */}
            </FormGroup>

            <FormGroup className='text-center mb-0'>
              <div className='font-weight-600 text-center mt-4 d-flex justify-content-center'>
                <a tabIndex={-1} className='text-muted small' href='https://klutch.app/privacy-policy' rel='noreferrer noopener' target='_blank' onClick={handleExternalLink}>
                  Privacy Policy
                </a>
                <span className='text-muted small mx-2'>|</span>
                <a tabIndex={-1} className='text-muted small' href='https://klutch.app/terms-of-service' rel='noreferrer noopener' target='_blank' onClick={handleExternalLink}>
                  Terms of Service
                </a>
              </div>
            </FormGroup>
          </LoginForm>
        )}
      </Formik>
    </>
  )
}
